// extracted by mini-css-extract-plugin
export var badge = "_f4-2";
export var detailsPanel = "_f4-0";
export var resultRow = "_f4-1";